import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { MapsAPILoader } from '@agm/core';
import { NgxImageGalleryComponent, GALLERY_IMAGE, GALLERY_CONF } from "ngx-image-gallery";
import { ApiConnectionService } from 'src/app/services/api-connection.service';
import { RecaptchaComponent } from 'ng-recaptcha';
import Swal from 'sweetalert2/dist/sweetalert2';

declare const $: any;
declare const gtag: any;

@Component({
  selector: 'app-construction-project-home',
  templateUrl: './construction-project-home.component.html',
  styleUrls: ['./construction-project-home.component.css']
})
export class ConstructionProjectHomeComponent implements OnInit {
  slug = null;

  slugProject = null;
  tabFilter: any = [
    { name: 'Todos', value: 'all' },
    { name: 'Vivienda VIS', value: 'VIS' },
    { name: 'Vivienda no VIS', value: 'noVIS' },
    { name: 'Sobre planos', value: 'plans' },
    { name: 'En construcción', value: 'construction' },
    { name: 'Entrega inmediata', value: 'immediately' },
  ];

  // filters
  type_properties = [
    { checked: false, type_property: 'Finca', slug: 'finca' },
    { checked: false, type_property: 'Casa', slug: 'casa' },
    { checked: false, type_property: 'Edificio', slug: 'edificio' },
    { checked: false, type_property: 'Bodega', slug: 'bodega' },
    { checked: false, type_property: 'Lote', slug: 'lote' },
    { checked: false, type_property: 'Apartamento', slug: 'apartamento' },
    { checked: false, type_property: 'Local', slug: 'local' },
    { checked: false, type_property: 'Consultorio', slug: 'consultorio' },
    { checked: false, type_property: 'Oficina', slug: 'oficina' },
    { checked: false, type_property: 'Parqueaderos', slug: 'parqueadero' },
  ];
  projectsRelated = [1, 2, 3, 4, 5, 6, 7, 8]

  number_rooms: any = [
    { name: '1 Habitación', value: '1', selected: false },
    { name: '2 Habitaciones', value: '2', selected: false },
    { name: '3 Habitaciones', value: '3', selected: false },
    { name: '3+ Habitaciones', value: '3+', selected: false },
  ]

  number_bathrooms: any = [
    { name: '1 baño', value: '1', selected: false },
    { name: '2 baños', value: '2', selected: false },
    { name: '3 baños', value: '3', selected: false },
    { name: '3+ baños', value: '3+', selected: false },
  ]

  number_parkings: any = [
    { name: '1 parqueadero', value: '1', selected: false },
    { name: '2 parqueaderos', value: '2', selected: false },
    { name: '3 parqueaderos', value: '3', selected: false },
    { name: '3+ parqueaderos', value: '3+', selected: false }
  ]

  number_strato: any = [
    { name: 'Estrato 1 ', value: '1', selected: false },
    { name: 'Estrato 2 ', value: '2', selected: false },
    { name: 'Estrato 3 ', value: '3', selected: false },
    { name: 'Estrato 4 ', value: '4', selected: false },
    { name: 'Estrato 5 ', value: '5', selected: false },
    { name: 'Estrato 6', value: '6', selected: false },
  ]

  area: any = {
    min: '',
    max: ''
  }

  publication_date: any = {
    from: '',
    to: ''
  }

  advantageZones: any = {
    'colegios': 'cancha',
    'universidades' : 'salon',
    'market' : 'huerta',
    'transporte' : 'rutas',
    'cc' : 'bicicleteros',
    'parques' : 'verdes',
    'campestre' : 'fogata',
    'comercial' : 'entretenimiento',
    'residencial' : 'porteria'
  }

  commonZones: any = [
    { icon: 'cancha', title: 'Cancha de tenis'},
    { icon: 'fogata', title: 'Fogata al aire libre' },
    { icon: 'porteria', title: 'Portería vigilada' },
    { icon: 'salon', title: 'Salón múltiple' },
    { icon: 'bienestar', title: 'Zona de bienestar' },
    { icon: 'rutas', title: 'Zona de espera para rutas' },
    { icon: 'entretenimiento', title: 'Zona de entretenimiento' },
    { icon: 'huerta', title: 'Huerta' },
    { icon: 'mirador', title: 'Mirador de estrellas' },
    { icon: 'bicicleteros', title: 'Bicicleteros' },
    { icon: 'basuras', title: 'Cuarto de basuras' },
    { icon: 'piscina', title: 'Piscina para adultos y niños' },
    { icon: 'verdes', title: 'Amplias zonas verdes' }

  ]

  lat = 4.674464;
  lng = -74.052157;
  zoom: number = 15;

  profile: any = {};
  project: any = {};
  version: boolean = false;

  openf: boolean = false;
  openContact: boolean = false;

  // models

  type: any = '';
  price: any = {
    min: 0,
    max: 0
  }

  zone_files:any = [];
  advantages_files: any = [];
  images:any = [];

  @ViewChild('captchaRef') public captchaRef: RecaptchaComponent;
  showCaptcha = false;
  graciasResponse = false;
  captcha: any;

  @ViewChild(NgxImageGalleryComponent) ngxImageGallery: NgxImageGalleryComponent;
  blueprints: any = [];

  conf: GALLERY_CONF = {
    imageOffset: '0px',
    showImageTitle: false,
    reactToMouseWheel: true,
    showExtUrlControl: false,
    reactToRightClick: true,
    imagePointer: true
  };



  constructor(
    protected http: ApiConnectionService,
    protected activateRoute: ActivatedRoute,
    protected mapsAPILoader: MapsAPILoader,
    protected apiService: ApiConnectionService,

  ) {
    this.activateRoute.params.subscribe(v => (this.slug = v.slug, this.slugProject = v.projectSlug));
    this.activateRoute.queryParams
      .subscribe(params => {
        console.log(params.v); // { orderby: "price" }
        if (params?.v == 2) {
          this.version = true;
        }
      }
      );
  }

  ngOnInit(): void {
    this.getConstructora()
    $(".collapse").click(function (event) {
      event.stopPropagation();
    });

    $('.accordion .btn').on('click', function (event) {
      let el = event.currentTarget;
      let validation = $(el).hasClass('collapsed');

      if (validation) {

      } else {
        setTimeout(function () {
          $(el).addClass('collapsed');
        }, 200);

        setTimeout(function () {
          $(el).next('.collapse').removeClass('show');
        }, 400);
      }

    });

    setTimeout(() => {
      $('.carouselrelated').owlCarousel({
        autoHeight: true,
        nav: false,
        dots: true,
        loop: true,
        margin: 15,
        items: 4,
        responsive: {
          // breakpoint from 0 up
          0: {
            items: 1,
          },
          768: {
            items: 2,
          },
          1024: {
            items: 4,
          }
        }
      });
    }, 2000);

  }


  getConstructora() {
    this.apiService.getData('profile/' + this.slug, { auth: false }).subscribe(
      (response) => {
        this.profile = response;
        console.log('PROFILE:', this.profile);

        this.getProyecto();
      },
      (error) => {
        window.location.href = '/usuario/perfil';
      }
    );
  }

  getProyecto() {
    this.apiService.getData('profile/' + this.slug + '/projects/' + this.slugProject + '?withData=true', { auth: false }).subscribe(
      (response) => {
        this.project = response;
        console.log('PROJ:', this.project);

        if (this.project.blueprints.length > 0) {
          for (const image of this.project.blueprints) {
              this.blueprints.push({
                url: image.image,
                thumbnailUrl: image.image,
              });
          }
        }


        this.zone_files = this.project?.images?.filter( (e:any) =>  e.typeof == 'zone_files');
        this.images = this.project?.images?.filter( (e:any) =>  e.typeof == 'files');

      },
      (error) => {
        window.location.href = '/';
      }
    );
  }

  // filter proyectos
  filterProyecto() {
    let url = 'profile/' + this.slug + '/projects/' + this.slugProject + '?withData=true';
    let rooms = this.selectedData(this.number_rooms)
    let bathrooms = this.selectedData(this.number_bathrooms)
    let parking = this.selectedData(this.number_parkings);
    let estrato = this.selectedData(this.number_strato);
    if (this.type) url += '&type=' + this.type
    if (rooms) url += `&rooms=${rooms}`
    if (bathrooms) url += `&bathrooms=${bathrooms}`
    if (parking) url += `&parking=${parking}`
    if (estrato) url += `&estrato=${estrato}`

    if (this.area.max > 0 || this.area.min > 0) {
      if (this.area.min > this.area.max && this.area.max > 0) {
        url += '&area=' + this.area.max + ',' + this.area.min + '';
      } else {
        url += '&area=' + this.area.min + ',' + this.area.max + '';
      }
    }
    if (this.price.max > 0 || this.price.min > 0) {
      if (this.price.min > this.price.max && this.price.max > 0) {
        url += '&price=' + this.price.max + ',' + this.price.min + '';
      } else {
        url += '&price=' + this.price.min + ',' + this.price.max + '';
      }
    }

    this.apiService.getData(url, { auth: false }).subscribe(
      (response) => {
        this.project = response;
        console.log(this.project);

      },
      (error) => {
        // window.location.href = '/';
      }
    );
  }

  clearFilters() {
    this.price.max = 0
    this.price.min = 0
    this.area.max = 0
    this.area.min = 0
    this.number_rooms.forEach((el:any) => {
      el.selected = false
    });

    this.number_bathrooms.forEach((el:any) => {
      el.selected = false
    });
  
    this.number_parkings.forEach((el:any) => {
      el.selected = false
    });
  }

  selectedData(value) {
    const selected = value.filter((e: any) => e.selected).map((e: any) => e.value).join(',');
    return selected;
  }

  // METHODS
  // open gallery
  openGallery(index: number = 0) {
    this.ngxImageGallery.open(index);
  }

  resolved(captchaResponse: string) {
    this.captcha = captchaResponse;
  }

  contact(f): void {
    if (f.form.status == 'VALID') {
      Swal.fire({
        title: 'Estamos notificando tu solicitud...',
        allowOutsideClick: false,
        allowEscapeKey: false,
        onBeforeOpen: () => Swal.showLoading(),
      });
      f.value['phone'] = f.value['phone'];
      f.value['metadata'] = {
        type: "Project",
        url : location.href
      };
      f.value['g-recaptcha-response'] = this.captcha;
      this.http
        .postData('contact', f.value, { auth: false })
        .subscribe(
          (response: any) => {
            gtag('event', 'Envío de formulario de contacto de proyecto', {
              event_category:
                'Boton de enviar del formulario en el detalle del proyecto',
              event_label: window.location.pathname,
            });
            $('#collapseContacto').toggleClass('transition');
            if ($('#contactModalMobile').hasClass('show'))
              $('#contactModalMobile').modal('toggle');
            Swal.close();
            f.form.reset();
            // $("#designmodal > div").remove();
            // $("#designmodal").addClass('p-5');
            // $("#designmodal").html(`
            //   <div class="container text-center justify-content-center p-5">
            //     <h1 style="font-size:10rem;color: #0096a3;"><i class="far fa-check-circle"></i></h1>
            //     <h2>¡Gracias por contactarte con el propietario del inmueble ${this.property.type_property.type_property} en ${this.property.type_offer} ${this.property.zone}, ${this.property.city}!</h2>
            //     <a class="d-block text-bold btn-pink text-white text-center m-auto" href="${window.location.href}">Regresar</a>
            //   </div>
            // `);
            this.graciasResponse = true;
            history.pushState(
              {},
              'Gracias por contactarte',
              `${window.location.pathname}/gracias`
            );
            gtag('event', 'page_view', {
              page_title: 'Gracias por contactarte',
              page_location: window.location.href,
              page_path: window.location.pathname,
            });
          },
          (error) => {
            if (error.status == 401) {
              Swal.fire({
                title:
                  'Para poder continuar por favor confirma que no esres un robot',
              }).then(() => {
                this.showCaptcha = true;
              });
            } else if (error.status == 400) {
              Swal.fire({
                title: 'Asegúrate que pusiste un correo válido',
              }).then(() => {
                this.captchaRef.reset();
              });
            } else {
              Swal.fire({
                title:
                  'En este momento no podemos atender tu solictud, por favor inténtalo más tarde',
              });
            }
          }
        );
    }
  }

  filterTabBy(e: any) {
    console.log(e);

  }

  generateUri(): string {
    return location.href;
  }

  copyLink() {
    var text = window.location.href;
    const selBox = document.createElement('textarea');
    selBox.style.position = 'fixed';
    selBox.style.left = '0';
    selBox.style.top = '0';
    selBox.style.opacity = '0';
    selBox.value = text;
    document.body.appendChild(selBox);
    selBox.focus();
    selBox.select();
    document.execCommand('copy');
    document.body.removeChild(selBox);
  }

  buildGoogleMapsImageUri(): string {
    return (
      'https://maps.googleapis.com/maps/api/staticmap?center="' +
      this.project.latitude +
      ',' +
      this.project.longitude +
      '"&maptype=roadmap&zoom=16&size=1000x500&markers=color:red|' +
      this.project.latitude +
      ',' +
      this.project.longitude +
      '&key=AIzaSyDwGE_CeEzo4IjbZD_YoQdNBqN1jKachWo'
    );
  }

  bgBanner(bg:any){
    let w = screen.width
    if (w < 991) {
      return 'background-image: linear-gradient(to right, rgb(0 0 0 / 55%), rgb(0 0 0 / 40%)), url('+ bg +')';
    }
  }

}
